import { fileObject } from "@boark/shared/types/file-object";
import {
  faChevronDown,
  faChevronRight,
} from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { useMemo, useState } from "react";

import { useGetFiles } from "../queries/get-files";
import { useLocale } from "../stores/locale";
import { Button } from "./button";
import { EmbeddedFileList } from "./embedded-file-list";
import { FileUpload } from "./file-upload";

export function ProcurementGeneralFiles({
  procurementId,
  readOnly = false,
}: {
  procurementId: string;
  readOnly?: boolean;
}) {
  const t = useLocale((state) => state.locale);
  const path = `procurement/${procurementId}`;
  const { data: objects, invalidate } = useGetFiles(path);
  const [expanded, setExpanded] = useState(false);

  const files = useMemo(() => {
    return (objects ?? []).filter(
      (
        object,
      ): object is fileObject & {
        type: "file";
        size: number;
        lastModified: Date;
      } => object.type === "file",
    );
  }, [objects]);
  const hasFiles = files.length > 0;

  return (
    <div className="border border-gray-300 rounded-xs bg-white">
      <div className="flex flex-wrap items-center justify-between gap-2 p-3">
        <p className="font-medium text-gray-900">
          {t.procurement.filesGeneral}
        </p>
        <div className="flex items-center gap-2 shrink-0">
          {hasFiles && (
            <Button
              severity="secondary"
              size="sm"
              onClick={() => setExpanded((value) => !value)}
            >
              <FontAwesomeIcon
                className="mr-1"
                icon={expanded ? faChevronDown : faChevronRight}
              />
              {t.procurement.organizationFilesCount.replace(
                "{count}",
                String(files.length),
              )}
            </Button>
          )}
          <FileUpload
            disabled={readOnly}
            path={path}
            onUpload={() => void invalidate()}
          />
        </div>
      </div>
      {hasFiles && expanded && (
        <EmbeddedFileList
          files={files}
          path={path}
          readOnly={readOnly}
          onChanged={() => void invalidate()}
        />
      )}
    </div>
  );
}
